"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuScreen = void 0;
var react_1 = __importDefault(require("react"));
var MainUI_1 = require("../MainUI");
var StandardScene_1 = require("../../game/Scenes/StandardScene");
var MenuScreen = /** @class */ (function (_super) {
    __extends(MenuScreen, _super);
    function MenuScreen(props) {
        var _this = _super.call(this, props) || this;
        _this.gameContainerRef = react_1.default.createRef();
        return _this;
    }
    MenuScreen.prototype.componentDidMount = function () {
        var container = this.gameContainerRef.current;
        if (container) {
            var scene = new StandardScene_1.StandardScene(container, container.offsetWidth, container.offsetHeight);
            scene.buildBoxesByWord("word");
        }
    };
    MenuScreen.prototype.onPlayClicked = function () {
        this.props.app.changeScreen(MainUI_1.AppScreen.Game);
    };
    MenuScreen.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "content" },
            react_1.default.createElement("div", { className: "logo" },
                react_1.default.createElement("img", { src: "images/logo.png", alt: "Guess Word" }),
                react_1.default.createElement("div", { className: "score" },
                    "Best ",
                    this.props.app.gameManager.getScoreData().highestScore)),
            react_1.default.createElement("div", { className: "game-container", ref: this.gameContainerRef }),
            react_1.default.createElement("button", { className: "btn btn-primary btn-block text-uppercase", onClick: this.onPlayClicked.bind(this) }, "Play")));
    };
    return MenuScreen;
}(react_1.default.Component));
exports.MenuScreen = MenuScreen;
